import { SSO } from "../../common/apiUrl/sso/ssoUrl";
import { API } from "../../common/model/objectTypes";
import { organizerRecycleBinInfo } from "../../utils/apiDescription/sso/recycleBin";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { organizerCommonRequestBody, recycleBinOrganizerParameter, recycleBinOrganizerResponseBody } from "../../utils/sso/apiObjects";
import { deleteRecycleBinOrganizerJsonRequestCurl, recycleBinOrganizerJsonRequestCurl, restoreRecycleBinOrganizerJsonRequestCurl } from "../../utils/sso/sampleJsonRequest";
import { recycleBinOrganizerJsonResponse } from "../../utils/sso/sampleJsonResponse";


const deleteRecycleBinOrganizer: API = {
    name: "Delete Recycle Bin Organizer",
    url: `${API_BASE_URL}/${SSO.RECYCLE_BIN.DELETE_RECYCLE_BIN_ORGANIZER_URL}`,
    method: "DEL",
    headers: requestHeaderWithCallback,
    apiInfo: organizerRecycleBinInfo.deleteRecycleBinOrganizer,
    requestBody: organizerCommonRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: deleteRecycleBinOrganizerJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

const recycleBinOrganizer: API = {
    name: "Recycle Bin Organizers",
    url: `${API_BASE_URL}/${SSO.RECYCLE_BIN.RECYCLE_BIN_ORGANIZER_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: organizerRecycleBinInfo.recycleBinOrganizer,
    requestBody: recycleBinOrganizerParameter,
    responseBody: recycleBinOrganizerResponseBody,
    jsonRequest: recycleBinOrganizerJsonRequestCurl,
    jsonResponse: recycleBinOrganizerJsonResponse,
}

const restoreRecycleBinOrganizer: API = {
    name: "Restore",
    url: `${API_BASE_URL}/${SSO.RECYCLE_BIN.RESTORE_RECYCLE_BIN_ORGANIZER_URL}`,
    method: "PUT",
    headers: requestHeaderWithCallback,
    apiInfo: organizerRecycleBinInfo.restoreRecycleBinOrganizer,
    requestBody: organizerCommonRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: restoreRecycleBinOrganizerJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'Recycle Bin':
            return deleteRecycleBinOrganizer;
        case 'All':
            return recycleBinOrganizer;  
        case 'Restore':
            return restoreRecycleBinOrganizer;
    }
}
